import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/ui-bits";
import { CredentialList } from "../components/CredentialList";

export default function Credentials() {
  const [projects, setProjects] = useState([]);
  const [clients, setClients] = useState([]);

  useEffect(() => {
    (async () => {
      try {
        const [p, c] = await Promise.all([api.get("/projects"), api.get("/clients")]);
        setProjects(p.data);
        setClients(c.data);
      } catch {}
    })();
  }, []);

  return (
    <div className="animate-fade-up" data-testid="credentials-page">
      <PageHeader overline="Tresor" title="Zugänge" testid="credentials-header" />
      <CredentialList projects={projects} clients={clients} />
    </div>
  );
}
